import React from 'react';

const BlueCheckedCard = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.599976" width="20" height="20" rx="10" fill="url(#paint0_radial_749_2193)" />
      <path d="M13.5913 7.94061L8.68188 12.85L6.5 10.6681" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <radialGradient id="paint0_radial_749_2193" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(28.2708 41.3166) rotate(-124.286) scale(63.1175 158.457)">
          <stop stopColor="#00B0CA" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>

  )
}

export default BlueCheckedCard;